import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Only import critical CSS needed for initial render
// Other CSS files are imported in their respective components
import './CssFiles/bureau.css';
import './CssFiles/newHome.css';
import './CssFiles/helloTrade.css';
import './CssFiles/form.css';
import './CssFiles/landingPage.css';
import './CssFiles/faq.css';
import './CssFiles/testimonial.css';
import './CssFiles/downloads.css';
import './CssFiles/benefitsAndProcess.css';
import './CssFiles/fixerra.css';
import './CssFiles/preApprovedOffer.css';
import './CssFiles/pp_tnc.css';
import './CssFiles/lenderPartner.css';
import './CssFiles/moreDetails.css';
import './CssFiles/emi.css';
import './CssFiles/pages/creditCards.css';
import './CssFiles/consentModal.css';


import reportWebVitals from './reportWebVitals';
import RootComponent from './Components/Root/RootComponent';
import ErrorBoundary from './Components/ErrorBoundary/ErrorBoundary';
import { LoginModalProvider } from "./Components/Common/LoginModalProvider";
import { HelmetProvider } from 'react-helmet-async';
import { markHtRedirectionStatus } from './utils';

import './config/sentry';

// Log Render started before React render (earliest point)
markHtRedirectionStatus("HT_RENDER_STARTED");

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <LoginModalProvider>
          <RootComponent />
        </LoginModalProvider>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
